<template lang="pug">
  transition(:name="`transition-${position}`")
    div.popup-container(
      v-if="visible"
      :class="`popup-container-${position}`"
      :style="{ backgroundColor: showMask ? 'rgba(0, 0, 0, 0.75)' : 'transparent' }"
      @touchmove.prevent
      @click.self="handleMaskClick"
    )
      .popup-container-body(
        :class="`popup-container-body-${position}`"
      )
        slot
</template>

<script>
export default {
  name: 'Popup',
  props: {
    // 位置
    position: {
      type: String,
      default: 'center',
    },
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 蒙层是否可关闭
    maskClosable: {
      type: Boolean,
      default: false,
    },
    // 是否显示蒙层
    showMask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 点击蒙层
    handleMaskClick() {
      if (this.maskClosable) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999;

  &.popup-container-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.popup-container-bottom {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  .popup-container-body-bottom {
    width: 100%;
  }
}

/* 动画-center */
.transition-center-enter-active,
.transition-center-leave-active {
  transition: opacity 0.3s ease;

  .popup-container-body-center {
    transition: all 0.3s ease;
  }
}

.transition-center-enter,
.transition-center-leave-to {
  opacity: 0;

  .popup-container-body-center {
    transform: scale(0.8);
  }
}

/* 动画-bottom */
.transition-bottom-enter-active,
.transition-bottom-leave-active {
  transition: opacity 0.3s ease;

  .popup-container-body-bottom {
    transition: transform 0.3s ease;
  }
}

.transition-bottom-enter,
.transition-bottom-leave-to {
  opacity: 0;

  .popup-container-body-bottom {
    transform: translateY(100%);
  }
}
</style>
